//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Approval from './approval.vue';
import Branch from './branch.vue';
export default {
  name: 'FlowNode',
  components: {
    Approval: Approval,
    Branch: Branch
  },
  props: {
    sourceData: {
      type: Object,
      default: function _default() {}
    },
    del: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    selectedId: {
      type: String,
      default: ''
    }
  }
};